import { FC, useEffect } from 'react';

import { getSelectedLandingPages, getSelectedNamedLandingPages } from '@features/landingPagesSlice';
import useTranslateLandingPages from '@hooks/useTranslateLandingPages';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderLandingPages: FC = () => {
  const selectedLandingPages = useSelector(getSelectedLandingPages);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateLandingPages();
  const navigate = useNavigate();

  const namedSelected = useSelector(getSelectedNamedLandingPages);

  useEffect(() => {
    if (!selectedLandingPages || !selectedLandingPages.length) navigate(ROUTES.EMAILS);
  }, [selectedLandingPages, navigate]);

  return (
    <NewOrderBase
      type={'landing pages'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedLandingPages}
      onSend={(data) => mutateAsync({ ...data, ids: selectedLandingPages })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderLandingPages;
